import { captureException } from '@sentry/react'
import { useQuery } from '@tanstack/react-query'
import { HttpUserMeResponse, httpUserMe } from '@/features/auth/http/auth.http'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { parseAxiosPromise } from '@/helpers/utils'

export const ME_QUERY_KEY = 'me'

export const useMe = () => {
	const accessToken = useAuthStore((state) => state.accessToken)

	return useQuery({
		queryKey: [ME_QUERY_KEY],
		queryFn: async () => {
			const user = await parseAxiosPromise({
				axiosPromise: httpUserMe(),
				onZodError: captureException,
				responseShape: HttpUserMeResponse
			})
			useAuthStore.setState(() => ({ user }))
			return user
		},
		enabled: !!accessToken
	})
}
